// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-shared-IconAndTitle-module__iconAndTitleContainer";
export { _1 as "iconAndTitleContainer" }
